export const DOCUMENT_TYPE_ABOUT = 'about';
